import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useTypedContext from "hooks/useTypedContext";
import { ModuleSettingsContext } from "views/Account/ModuleSettings/Context";

import { showWebhookDetailsDrawer } from "../../components/WebhookDetailsDrawer";
import WebhookDropdown from "../../components/WebhookDropdown";
import { showWebhookDrawerForm } from "../../components/WebhookFormDrawer";
import { WebhookIntegrationWithTimestamp } from "../types";

const REFETCH_QUERIES_ON_DELETE = ["GetModuleWebhooks"];

const ModuleWebhooksTableDropdownCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<WebhookIntegrationWithTimestamp>) => {
  const { module, canManageModule } = useTypedContext(ModuleSettingsContext);

  const handleEditClick = () => {
    showWebhookDrawerForm({ id: webhook.id, webhook, moduleId: module.id });
  };

  const handleDetailsClick = () => {
    showWebhookDetailsDrawer({ id: webhook.id, webhook });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <WebhookDropdown
        id={webhook.id}
        endpoint={webhook.endpoint}
        refetchQueriesOnDelete={REFETCH_QUERIES_ON_DELETE}
        onEditClick={handleEditClick}
        onDetailsClick={handleDetailsClick}
        moduleId={module.id}
        canManageModule={canManageModule}
      />
    </TableSimpleCell>
  );
};

export default ModuleWebhooksTableDropdownCell;
